module.exports = __webpack_public_path__ + "img/20.f6a363be.png";